import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, light = false }) => (
  <p
    className={`inline-flex items-center gap-3 text-xs font-bold tracking-[0.3em] uppercase ${
      light ? "text-marigold" : "text-verm"
    }`}
    data-testid="eyebrow-label"
  >
    <span className={`h-px w-8 ${light ? "bg-marigold" : "bg-verm"}`} />
    {children}
    <span className={`h-px w-8 ${light ? "bg-marigold" : "bg-verm"}`} />
  </p>
);

export default Reveal;
